import React from "react";

type BenefitGlassCardProps = {
  title: string;
  description: string;
  icon: string;
};

const BenefitGlassCard: React.FC<BenefitGlassCardProps> = ({
  title,
  description,
  icon,
}) => {
  return (
    <div
      className="wow fadeInUp"
      style={{
        height: "100%",
        padding: "28px 30px",
        borderRadius: "18px",
        background: "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))",
        border: "1px solid rgba(255,255,255,0.12)",
        backdropFilter: "blur(12px)",
        display: "flex",
        gap: "22px",
        transition: "0.35s",
      }}
    >
      {/* ICON */}
      <div
        style={{
          minWidth: 56,
          height: 56,
          borderRadius: "14px",
          background: "rgba(255,255,255,0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={icon} alt={title} style={{ width: 34 }} />
      </div>

      {/* DIVIDER */}
      <div
        style={{
          width: 1,
          background: "rgba(255,255,255,0.15)",
        }}
      />

      {/* CONTENT */}
      <div>
        <h4
          style={{
            color: "#fff",
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          {title}
        </h4>

        <p
          style={{
            color: "rgba(255,255,255,0.85)",
            fontSize: 15,
            lineHeight: "1.65",
            margin: 0,
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default BenefitGlassCard;
